import angular from 'angular';
import contactPoints from './contactPoints';

export default angular
  .module('components.contactPoints', [])
  .component('contactPoints', contactPoints).name;
